
export interface SiteMapEntry {
  name: string;
  subEntries?: SiteMapEntry[];
  key?: string;
}

const sitemap: SiteMapEntry[] = [
  {
    "name": "Best Practices and Limitations",
    "subEntries": [
      {
        "name": "Database Product",
        "subEntries": [
          {
            "name": "Best Practices and Limitations",
            "key": "/best_practices_and_limitations/database_product/best_practices_and_limitations"
          },
          {
            "name": "MongoDB Encryption Limitations",
            "key": "/best_practices_and_limitations/database_product/mongodb_encryption_limitations"
          }
        ]
      },
      {
        "name": "OnData SecureFile",
        "subEntries": [
          {
            "name": "Best Practices and Limitations",
            "key": "/best_practices_and_limitations/ondata_securefile/best_practices_and_limitations"
          }
        ]
      }
    ]
  },
  {
    "name": "How-to Guides",
    "subEntries": [
      {
        "name": "Backup and Validation",
        "subEntries": [
          {
            "name": "DB2",
            "key": "/how-to_guides/backup_and_validation/db2"
          },
          {
            "name": "MariaDB",
            "key": "/how-to_guides/backup_and_validation/mariadb"
          },
          {
            "name": "Microsoft SQL Server",
            "key": "/how-to_guides/backup_and_validation/microsoft sql server"
          },
          {
            "name": "MySQL",
            "key": "/how-to_guides/backup_and_validation/mysql"
          },
          {
            "name": "Oracle",
            "key": "/how-to_guides/backup_and_validation/oracle"
          },
          {
            "name": "PostgreSQL",
            "key": "/how-to_guides/backup_and_validation/postgresql"
          },
          {
            "name": "Snowflake",
            "key": "/how-to_guides/backup_and_validation/snowflake"
          }
        ]
      },
      {
        "name": "Database Download",
        "subEntries": [
          {
            "name": "Download Databases",
            "key": "/how-to_guides/database_download/download databases"
          }
        ]
      },
      {
        "name": "Drivers",
        "subEntries": [
          {
            "name": "Apply Encryption Setting Changes",
            "key": "/how-to_guides/drivers/apply_encryption_setting_changes"
          },
          {
            "name": "Client Access Control",
            "key": "/how-to_guides/drivers/client_access_control"
          },
          {
            "name": "Client Registration",
            "key": "/how-to_guides/drivers/client_registration"
          },
          {
            "name": "OnData ODBC Driver",
            "key": "/how-to_guides/drivers/ondata odbc driver"
          },
          {
            "name": "OnData JDBC",
            "key": "/how-to_guides/drivers/ondata_jdbc"
          },
          {
            "name": "OnData SqlClient",
            "key": "/how-to_guides/drivers/ondata_sqlclient"
          }
        ]
      },
      {
        "name": "Encryption",
        "subEntries": [
          {
            "name": "Data Information Types",
            "key": "/how-to_guides/encryption/data_information_types"
          },
          {
            "name": "Encryption Rules",
            "key": "/how-to_guides/encryption/encryption_rules"
          },
          {
            "name": "Encryption Tool",
            "key": "/how-to_guides/encryption/encryption_tool"
          },
          {
            "name": "Encryption Tool V2",
            "key": "/how-to_guides/encryption/encryption_tool_v2"
          },
          {
            "name": "Steps to Encrypt SQL Server Database",
            "key": "/how-to_guides/encryption/steps to encrypt sql server database"
          }
        ]
      },
      {
        "name": "Portal Configuration",
        "subEntries": [
          {
            "name": "Configuring Roles In Entra ID",
            "key": "/how-to_guides/portal_configuration/configuring_roles_in_entra_id"
          },
          {
            "name": "Custom Cloud Subscription",
            "key": "/how-to_guides/portal_configuration/custom_cloud_subscription"
          },
          {
            "name": "Data Access Roles",
            "key": "/how-to_guides/portal_configuration/data_access_roles"
          },
          {
            "name": "Microsoft Entra ID Integration",
            "key": "/how-to_guides/portal_configuration/microsoft_entra_id_integration"
          },
          {
            "name": "OnData Application Roles",
            "key": "/how-to_guides/portal_configuration/ondata_application_roles"
          },
          {
            "name": "Use Custom Key Vault",
            "key": "/how-to_guides/portal_configuration/use_custom_key_vault"
          }
        ]
      },
      {
        "name": "SecureFile",
        "subEntries": [
          {
            "name": "Classification and Protection Rules",
            "key": "/how-to_guides/securefile/classification_and_protection_rules"
          },
          {
            "name": "Deploy Data Analyzer",
            "key": "/how-to_guides/securefile/deploy_data_analyzer"
          },
          {
            "name": "Document Types",
            "key": "/how-to_guides/securefile/document_types"
          },
          {
            "name": "File Information Types",
            "key": "/how-to_guides/securefile/file_information_types"
          },
          {
            "name": "Install SecureFile",
            "key": "/how-to_guides/securefile/install_securefile"
          },
          {
            "name": "SecureFile Settings",
            "key": "/how-to_guides/securefile/securefile_settings"
          },
          {
            "name": "Sharing Files with External Users",
            "key": "/how-to_guides/securefile/sharing_files_with_external_users"
          },
          {
            "name": "Silent Installation and Registration",
            "key": "/how-to_guides/securefile/silent_installation_and_registration"
          },
          {
            "name": "Using SecureFile",
            "key": "/how-to_guides/securefile/using_securefile"
          }
        ]
      }
    ]
  },
  {
    "name": "Release Notes",
    "subEntries": [
      {
        "name": "Release 1.1.33",
        "key": "/release_notes/release_1.1.33"
      },
      {
        "name": "Release 2.0.48",
        "key": "/release_notes/release_2.0.48"
      },
      {
        "name": "Release 2.1.57",
        "key": "/release_notes/release_2.1.57"
      }
    ]
  }
];

export default sitemap
  